import { JSONUIProvider } from "@json-render/react";
import { Renderer } from "@json-render/react";
import type { Spec } from "@json-render/react";
import { registry } from "./registry";
import { NomniDispatch, type DispatchFn } from "./dispatch";

/**
 * Wraps the json-render Renderer with the FULL provider stack
 * (state + visibility + validation + action). Using StateProvider alone
 * breaks components that call useVisibility/useValidation internally —
 * a bug we shipped once and gated against with verify-served-surface.
 *
 * Per-click params (outletId, poId) travel via a NomniDispatch React
 * context — see render/dispatch.ts.
 */
export function Render({
  spec,
  initialState,
  onAction,
}: {
  spec: Spec;
  initialState?: Record<string, unknown>;
  onAction?: DispatchFn;
}) {
  const dispatch: DispatchFn = (a, p) => onAction?.(a, p);
  return (
    <NomniDispatch.Provider value={dispatch}>
      <JSONUIProvider registry={registry} initialState={initialState ?? {}}>
        <Renderer spec={spec} registry={registry} />
      </JSONUIProvider>
    </NomniDispatch.Provider>
  );
}
